import { QueryClient } from '@tanstack/react-query';

/**
 * Builds the app-wide React Query client.
 *
 * Defaults carried over deliberately from the legacy app so migrated screens
 * behave the same:
 *
 * - `retry: false` - the backend answers business failures with HTTP 200, so a
 *   rejection here is a real transport error and retrying it three times only
 *   delays the error state the user needs to see.
 * - `refetchOnWindowFocus: false` - these are dense admin tables; refetching every
 *   one of them on alt-tab was measurably worse than stale data.
 *
 * `staleTime` is the one thing NOT set globally: the right value is per-query
 * (a vendor list and an invoice total have nothing in common), and a global
 * default would quietly apply to every future hook. Set it per `useQuery`.
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
